import { useContext } from 'react'
import { NotificationContext } from '../components/Notification/NotificationProvider'
export const useNotificationProvider = () => {
  return useContext(NotificationContext)
}
